import React from "react";
import TabSelection from "../../components/SelectContent/TabSelection";

import { setSpectatorTab } from "../../state/slices/generalSlice";
import SpectateTRLocal from "./SpectateTRLocal";
import SpectateCos from "./SpectateCos";
import SpectateCwa from "./SpectateCwa";
import SpectateFsr from "./SpectateFsr";

import {
  CarFilled,
  CarryOutOutlined,
  FileDoneOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const SpectatorPage = () => {
  const menuItems = [
    {
      key: "tr-local",
      label: "Local Travel Request",
      component: <SpectateTRLocal />,
      icon: <CarFilled />,
    },
    {
      key: "cos",
      label: "Certificate of Service",
      component: <SpectateCos />,
      icon: <CarryOutOutlined />,
    },
    {
      key: "cwa",
      label: "Certificate of Work Accomplishment",
      component: <SpectateCwa />,
      icon: <FileDoneOutlined />,
    },
    {
      key: "fsr",
      label: "Faculty Service Record",
      component: <SpectateFsr />,
      icon: <FileTextOutlined />,
    },
  ];

  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="spectatorCurrentTab"
        setTabAction={setSpectatorTab}
      />
    </>
  );
};

export default SpectatorPage;
